import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockRegisterProvider } from '../facility/stockRegister/ContextAPI';
import Index from '../facility/stockRegister/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityStockRegister() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-stock-register']) return <PermissionDenied />;

    return (
        <StockRegisterProvider>
            <Index />
        </StockRegisterProvider>
    );
}
